import { Avatar, Box, Grid, Paper } from '@mui/material'
import React from 'react'
import image from '../../../assets/images/user.png'
import { RegularText, SmallText } from '../../helpers'
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { customStyles, justifyCenter, spaceBetween } from '../../../styles';
import { RatingStars } from './RatingStars';

export const InfoDelivery = () => {
  return (
    <Paper sx={{ padding: 1, marginTop: 1 }}>

    <Grid container spacing={1}>
      <Grid item xs={2} sx={ justifyCenter }>
        <Avatar src={image} alt="username" sx={{ width: 50, height: 50 }}/>
      </Grid>
      <Grid item xs={7}>
        <RegularText text="Domingo Periña"/>
        <SmallText text="Precio x litro: 15.75"/>
        <SmallText text="Calificación del repartidor:"/>
      </Grid>
      <Grid item xs={3} sx={{ ...spaceBetween, flexDirection: 'column', alignItems: 'flex-end'}}>
        <Box sx={{...justifyCenter,  backgroundColor: customStyles.colors.main, color: customStyles.colors.backgroundColor, width: 80, height: 30, borderRadius: 1}}>
          <RegularText text="4.8"/>
          <StarRoundedIcon />
        </Box>
        <RatingStars rating={4.5}/>
      </Grid>
    </Grid>
    </Paper>
  )
}
